import { Link } from "react-router-dom";
import { LOGO_URL } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { useCart } from "../lib/cart";
import LangSwitcher from "./LangSwitcher";

export default function Header({ showAdmin = true }) {
  const { t } = useI18n();
  const { count, setOpen } = useCart();
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 backdrop-blur-xl bg-black/70 border-b border-white/10"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between gap-4">
        <Link
          to="/"
          className="flex items-center gap-3 group shrink-0"
          data-testid="header-logo-link"
        >
          <img
            src={LOGO_URL}
            alt="ALLSTAR"
            className="h-10 w-10 object-contain"
          />
          <span className="font-display text-xl md:text-2xl uppercase tracking-tighter text-white group-hover:text-green-400 transition-colors">
            ALLSTAR
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-10 text-sm uppercase tracking-widest text-zinc-400">
          <a
            href="#shop"
            className="hover:text-white transition-colors"
            data-testid="nav-shop"
          >
            {t("nav_shop")}
          </a>
          <a
            href="#drops"
            className="hover:text-white transition-colors"
            data-testid="nav-drops"
          >
            {t("nav_drops")}
          </a>
          <a
            href="#story"
            className="hover:text-white transition-colors"
            data-testid="nav-story"
          >
            {t("nav_story")}
          </a>
          <a
            href="#contact"
            className="hover:text-white transition-colors"
            data-testid="nav-contact"
          >
            {t("nav_contact")}
          </a>
        </nav>

        <div className="flex items-center gap-3">
          <LangSwitcher />
          {showAdmin && (
            <Link
              to="/admin"
              data-testid="header-admin-link"
              className="hidden md:inline-flex items-center text-xs uppercase tracking-widest text-zinc-500 hover:text-green-400 transition-colors border border-zinc-800 hover:border-green-400 px-4 py-2"
            >
              {t("nav_admin")}
            </Link>
          )}
          <button
            onClick={() => setOpen(true)}
            data-testid="header-cart-btn"
            className="text-xs uppercase tracking-widest bg-green-500 text-black px-5 py-3 font-bold hover:bg-green-400 transition-colors whitespace-nowrap"
          >
            {t("cart")} · {count}
          </button>
        </div>
      </div>

      {/* Mobile lang switcher */}
      <div className="md:hidden border-t border-zinc-900 px-6 py-2 flex justify-end">
        <LangSwitcher compact />
      </div>
    </header>
  );
}
